import { render, staticRenderFns } from "./grade_detail.vue?vue&type=template&id=fdbe663e"
import script from "./grade_detail.vue?vue&type=script&lang=js"
export * from "./grade_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports